// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { boolean } from "@altostra/type-validations/lib/primitives";

export const isGetMessagePrioritizationHasFrequencyCappingRulesResult = objectOf({
  has_frequency_capping_rules: boolean,
});
